import { toast } from "../toast/toast";

export function errorMessage(message: string, error: unknown | string) {
  toast.error(
    `${message} ${error instanceof Error ? error.message : error}`
  );
  console.error(message, error);
}
